import { AddDiscountCode } from '@/pages/components/discount-code/AddDiscountCode';
import { FormTitleAndLogo } from '@/pages/components/Form';
import { ConsultEligibleDoctor, ConsultEligibleDoctorParagraph } from '@/pages/ConsultEligibleDoctor';
import {
  ImmediateConsultConfirmationContent,
  ImmediateConsultConfirmationTitle,
} from '@/pages/ConsultEligibleDoctorForms/ImmediateConsultConfirmation';
import type { Step } from '@montugroup/form-builder';

export const consultEligibleDoctorSteps = (): Step[] => [
  {
    id: 1,
    type: 'section',
    hideBackButton: true,
    formTitle: <FormTitleAndLogo>Thank you, you&apos;re all set to see a doctor.</FormTitleAndLogo>,
    content: [
      {
        type: 'custom',
        component: <ConsultEligibleDoctorParagraph />,
      },
      {
        type: 'custom',
        component: <AddDiscountCode showNoCodeText={false} />,
      },
      {
        type: 'custom',
        component: <ConsultEligibleDoctor />,
      },
    ],
    nextButtonConfig: {
      text: '',
    },
  } as Step,
  {
    id: 2,
    type: 'section',
    hideBackButton: true,
    formTitle: (
      <FormTitleAndLogo>
        <ImmediateConsultConfirmationTitle />
      </FormTitleAndLogo>
    ),
    content: [
      {
        type: 'custom',
        component: <ImmediateConsultConfirmationContent />,
      },
    ],
    nextButtonConfig: {
      text: '',
    },
  } as Step,
];
